var map = {
	"./bitbox.jpg": "176e",
	"./finney.jpg": "fed1",
	"./keepkey.jpg": "449b",
	"./ledger.jpg": "654e",
	"./secalot.jpg": "42f2",
	"./trezor.jpg": "06ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eb70";